import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import { useSelector } from "react-redux";
const Consultant = (props) => {
  const { t } = useTranslation();
  const language = useSelector((state)=> state.languages?.data)

  const [attributes] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "academicTitle",
      name: "academicTitle",
      validation: "",
      default: "",
      label: "title",
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: false,
      update: false,
      apiType: "CSV",
      selectApi: "Prof.,Dr.",
    },
    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: false,
    },
    {
      type: "multiSelect",
      placeholder: "employee",
      name: "user",
      tags: [
        { item: "title", title: "role", collection: "role" },
      ],
      validation: "",
      default: "",
      label: "employee",
      showItem: "employee",
      required: true,
      view: false,
      add: true,
      update: false,
      apiType: "API",
      selectApi: "user/select",
      customClass: "full",
    },
    {
      type: "hidden",
      placeholder: "consultant",
      name: "consultant",
      validation: "",
      default: "true",
      label: "consultant",
      showItem: "",
      required: true,
      view: false,
      add: true,
      update: false,
    },
    {
      type: "select",
      placeholder: "consultant",
      name: "consultant",
      validation: "",
      default: "true",
      label: "consultant",
      showItem: "",
      required: true,
      view: false,
      add: false,
      update: true,
      apiType: "JSON",
      selectApi:[
        {id: "true", value: t("True")},
        {id: "false", value: t("False")}
      ]
    },
  ]);


  //to update the page title
  useEffect(() => {
    document.title = `${t("Consultant")} - Whistleblowing24`;
  }, [t]);
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable {...props} api={`user`} itemTitle={"fullName"} shortName={`Consultant`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Consultant);
